import JhiDataUtils from '@/shared/data/data-utils.service';
import { IAddonCategory } from '@/shared/model/addon-category.model';
import { IAddon } from '@/shared/model/addon.model';
import { IAvailability } from '@/shared/model/availability.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IMenuCategory } from '@/shared/model/menu-category.model';
import { IMenuVariant } from '@/shared/model/menu-variant.model';
import { IMenu } from '@/shared/model/menu.model';
import { IMultiLanguage } from '@/shared/model/multi-language.model';
import { IProductInfoAdditive } from '@/shared/model/product-info-additive.model';
import { IProductInfoAllergen } from '@/shared/model/product-info-allergen.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { MutationTree } from 'vuex';
import { MenusManagementType } from './types';

const jhiDataUtils = new JhiDataUtils();

export const mutations: MutationTree<MenusManagementType> = {
  setMenuCategoriesTab(state, newMenuCategoriesTab: number): void {
    state.menuCategoriesTab = newMenuCategoriesTab;
  },
  setMenusTab(state, newMenusTab: number[]): void {
    state.menusTab = newMenusTab;
  },
  setStepper(state, newStepper: number): void {
    state.stepper = newStepper;
  },
  setMenuCategories(state, newMenuCategories: IMenuCategory[]): void {
    state.menuCategories = newMenuCategories;
  },
  setProoductInfos(state, productInfos: { allergens: IProductInfoAllergen[]; additives: IProductInfoAdditive[] }): void {
    state.allergens = productInfos.allergens;
    state.additives = productInfos.additives;
  },
  setEnabled(state, newEnabled: boolean): void {
    state.menuCategories[state.menuCategoriesTab].enabled = newEnabled;
  },
  setNonfood(state, newNonfood: boolean): void {
    state.menuCategories[state.menuCategoriesTab].nonfood = newNonfood;
    state.menuCategories[state.menuCategoriesTab].menus.forEach(menu => (menu.nonfood = newNonfood));
  },
  setTitle(state, newTitle: IMultiLanguage): void {
    state.menuCategories[state.menuCategoriesTab].title = newTitle;
  },
  setDescription(state, newDescription: IMultiLanguage): void {
    state.menuCategories[state.menuCategoriesTab].description = newDescription;
  },
  setDiscount(state, newDiscount: IDiscount): void {
    state.menuCategories[state.menuCategoriesTab].discount = newDiscount;
  },
  setMenus(state, newMenus: IMenu[]): void {
    state.menuCategories[state.menuCategoriesTab].menus = newMenus;
  },
  setMenuVariants(state, newMenuVariants: IMenuVariant[]): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants = newMenuVariants;
  },
  setMenuAddonCategories(state, newMenuAddonCategories: IAddonCategory[]): void {
    state.menuCategories[state.menuCategoriesTab].menus[
      state.menusTab[state.menuCategoriesTab]
    ].menuVariants[0].addonCategories = newMenuAddonCategories;
  },
  setMenuCategoryAvailabilities(state, newAvailabilities: IAvailability[]): void {
    state.menuCategories[state.menuCategoriesTab].availabilities = newAvailabilities;
  },
  setMenuVariantAvailabilities(state, newAvailabilities: IAvailability[]): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper || 0
    ].availabilities = newAvailabilities;
  },
  setRestaurant(state, newRestaurant: IRestaurant): void {
    state.menuCategories[state.menuCategoriesTab].restaurant = newRestaurant;
  },
  addNewMenuCategory(state, newMenuCategory: IMenu): void {
    state.menuCategories.push(newMenuCategory);
    setTimeout(() => {
      state.menuCategoriesTab = state.menuCategories.length - 1;
    }, 1);
  },
  deleteMenuCategory(state): void {
    state.menuCategories.splice(state.menuCategoriesTab, 1);
    for (let i = state.menuCategoriesTab; i < state.menuCategories.length; i++) {
      state.menuCategories[i].ordinal--;
    }
    state.menuCategoriesTab--;
  },
  setImage(state, newImage: string): void {
    state.menuCategories[state.menuCategoriesTab].image = newImage;
  },
  setImageContentType(state, newImageContentType: string): void {
    state.menuCategories[state.menuCategoriesTab].imageContentType = newImageContentType;
  },
  addNewMenu(state, newMenu: IMenu): void {
    state.menuCategories[state.menuCategoriesTab].menus = state.menuCategories[state.menuCategoriesTab].menus ?? [];
    state.menuCategories[state.menuCategoriesTab].menus.push(newMenu);
    state.menusTab[state.menuCategoriesTab] = state.menuCategories[state.menuCategoriesTab].menus.length - 1;
  },
  deleteMenu(state): void {
    state.menuCategories[state.menuCategoriesTab].menus.splice(state.menusTab[state.menuCategoriesTab], 1);
    for (let i = state.menusTab[state.menuCategoriesTab]; i < state.menuCategories[state.menuCategoriesTab].menus.length; i++) {
      state.menuCategories[state.menuCategoriesTab].menus[i].ordinal--;
    }
  },
  setMenuImage(state, menuImageFile: File): void {
    jhiDataUtils.setFileData(
      menuImageFile,
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]],
      'image'
    );
  },
  setMenuImage64(state, menuImageFile: string): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].image = menuImageFile;
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].imageContentType = 'image/jpeg';
  },
  addNewMenuVariant(state, newMenuVariant: IMenuVariant): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants =
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants ?? [];

    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants.push(newMenuVariant);
  },
  deleteMenuVariant(state): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants.splice(state.stepper, 1);
    for (
      let i = state.stepper;
      i < state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants.length;
      i++
    ) {
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[i].ordinal--;
    }
  },
  addNewAddonCategory(state, { newAddonCategory }: { newAddonCategory: IAddonCategory }): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper
    ].addonCategories =
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
        .addonCategories ?? [];

    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper
    ].addonCategories.push(newAddonCategory);
  },
  deleteAddonCategory(state, i: number): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper
    ].addonCategories.splice(i, 1);
    for (
      let j = i;
      j <
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
        .addonCategories.length;
      j++
    ) {
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
        .addonCategories[j].ordinal--;
    }
  },
  addNewAddon(state, { newAddon, tab }: { newAddon: IAddon; tab: number }): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper
    ].addonCategories[tab].addons.push(newAddon);
  },
  deleteAddon(state, { i, j }: { i: number; j: number }): void {
    state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper
    ].addonCategories[i].addons.splice(j, 1);
    for (
      let k = j;
      k <
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
        .addonCategories[i].addons.length;
      k++
    ) {
      state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
        .addonCategories[i].addons[k].ordinal--;
    }
  },
};
